import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: "bd8fd65d-2b80-48fb-b3f3-3d54fd98f8aa",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/puma_3_fytgq0.jpg",
    src: "https://www.youtube.com/embed/nPfTMSAHVnM",
    title: "Puma Rollin Wild Rider Unboxing",
    description:
      "Today, we are unboxing the all new Puma Rollin Wild Rider which resonates with the youth culture This silhouette brings a whole new dimension to the Rider family, with fresh layers of material and a raw, edgy look.",
    creator: "Bobby Solez",
    date: "Jun 5, 2021",
    category: "puma",
  },
  {
    _id: "b78538a7-06cc-41bc-aff1-633890cb197e",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/puma_2_lddlct.jpg",
    src: "https://www.youtube.com/embed/DeYDTqJDG5I",
    title: "PUMA Sneakers You need",
    description:
      "Today on SneakerTalk we cover the top 10 Puma Sneakers you need in your collection! These are all my top Puma sneakers as of recently! Many Puma RS-X, Puma RS-X3, Puma Thunder Spectra and more!LINKS TO SOME SNEAKERS BELOW!",
    creator: "Sneaker Talk",
    date: "Mar 16, 2020",
    category: "puma",
  },
  {
    _id: "337303c5-85f1-4a0f-b485-e9d73f37532a",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/puma_1_anljoz.jpg",
    src: "https://www.youtube.com/embed/myG1sbnfv6s",
    title: " Best Budget Puma Shoes",
    description:
      "UNBOXING: BEST BUDGET WHITE SHOES/SNEAKERS on AMAZON 🔥 Shoes Haul Review 2021 | Puma, Red Tape, Bacca Bucci, Sports star",
    creator: "One Chance",
    date: "Oct 18, 2021",
    category: "puma",
  },
  {
    _id: "9b0d420d-04aa-4e6f-91a0-c0c9d5541b0e",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/adidas_1_qtvmrc.jpg",
    src: "https://www.youtube.com/embed/9jtkNI4ybHI",
    title: "Top 10 ADIDAS Sneakers 2021",
    description:
      "Today we're counting down the Top 10 Adidas Shoe that you can rock right now in 2021! Check out these sneaker and don't forget to like,share & subscribe",
    creator: "Seth Fowler",
    date: "Jun 24, 2021",
    category: "adidas",
  },
  {
    _id: "3d353de2-f53f-4b00-a1d5-46824fa5a1dd",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/adidas_3_f9kipc.jpg",
    src: "https://www.youtube.com/embed/4J_kxwT9zX4",
    title: "The Adidas Ultra Boost",
    description:
      "From the complete knitted uppers to boxing the complete pair, this short exploration  in the construction of the Ultra Boost sheds light on the breakdown of the minimal, lightweight running shoe, and the attention to detail implemented by the workers.",
    creator: "Hypebeast",
    date: "Jan 30, 2015",
    category: "adidas",
  },
  {
    _id: "8d65b832-0a1f-407a-812d-8103aead3b28",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093806/video%20Library/adidas_2_gulgrv.jpg",
    src: "https://www.youtube.com/embed/wMxqFtD-CCw",
    title: "Adidas Cricket Shoes Unboxing",
    description:
      "In this video we'll be unboxing Size 10 adidas performance series cricket shoes CRI HASE CK0880, so do watch till the end.",
    creator: "PC Gaming & Sports",
    date: "Dec 27, 2018",
    category: "adidas",
  },
  {
    _id: "1c9ede91-a255-452d-aae0-62cb4ed3c4cc",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/jordan_1_tjl0uz.jpg",
    src: "https://www.youtube.com/embed/vgyJQ_bzpCY",
    title: "Unboxing Every Air Jordan Sneaker",
    description:
      " Unboxing every Air Jordan sneaker released during Michael Jordan's incredible professional basketball career.",
    creator: "Unbox Therapy",
    date: "Jun 12, 2017",
    category: "jordan",
  },
  {
    _id: "357f37b1-50b1-4f45-b53a-404cd6134e62",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093806/video%20Library/jordan_2_gvaqqe.jpg",
    src: "https://www.youtube.com/embed/p8HhmCv45xo",
    title: "Top 5 Jordan 1’s under ₹20000",
    description:
      "In this video we will be showing you Top 5 Jordan Snekaers under the most minimal range, do grab your deal and don't forget to like & share",
    creator: "Karan Khatri",
    date: "Nov 26, 2021",
    category: "jordan",
  },
  {
    _id: "231a15f6-ca5d-430c-8c12-d119cb750e09",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093807/video%20Library/jordan_3_our4xy.jpg",
    src: "https://www.youtube.com/embed/dDEIpuApenE",
    title: "Air Jordan 1-35",
    description:
      "The Air Jordan 35 is set to release this coming October 2020.  Lets go back and watch the evolution of Air Jordan from 1 - 35. ",
    creator: "Englatero Kicks",
    date: "Sep 15, 2020",
    category: "jordan",
  },
  {
    _id: "30d03731-830c-488f-aa26-9f004af18c18",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093806/video%20Library/converse_2_bbjw92.jpg",
    src: "https://www.youtube.com/embed/a5w-Nv7_GQ4",
    title: "Unboxing : My All Converse Sneaker",
    description:
      "Unboxing : My All Converse Sneaker/Shoe Collection 2021 | White Snekers, Hightop sneakers, Canvas Shoes, Chuck Taylor, Chuck 70",
    creator: "One Chance",
    date: "Dec 16, 2021",
    category: "converse",
  },
  {
    _id: "5698e98e-5943-48ce-af0a-e0bdb77557e6",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093806/video%20Library/converse_3_ogsnnp.jpg",
    src: "https://www.youtube.com/embed/UJXFbqWuw9A",
    title: "Converse High Top vs Low Top",
    description:
      "You guys seem to love these shoes and I get asked often on the channel which is better between the high top and the low top. Rather than answer the same question over and over, I thought it was time I made a video to help you decide.",
    creator: "Harry Has",
    date: "Dec 4, 2020",
    category: "converse",
  },
  {
    _id: "fbf364b3-57da-46dd-96a4-24ecbc3e912a",
    image:
      "https://res.cloudinary.com/doohtm4bs/image/upload/v1650093806/video%20Library/converse_1_xm7vvj.jpg",
    src: "https://www.youtube.com/embed/iimG6D0VXQ0",
    title: "5 Types of Converse",
    description:
      "In this video we will see Top 5 TYPES Of CONVERSE To Have and what are the Best CONVERSE Shoes in 2021",
    creator: "The Sneaker Guy",
    date: "Jul 16, 2021",
    category: "converse",
  },
];
